export const getAverageValue = (values: number[]): number => {
  const total = values.reduce<number>((acc, value) => (acc += value), 0);
  const valuesCount = values.length || 0;

  return total / valuesCount;
};
